<template>
    <div class="fakeddcontainer cursor-pointer" >
        <p class="fakedd"
           @click.stop="disabled ? null : (dd_open ? dd_open = false : dd_open = true)"
           :class="{'disabled':disabled}"
           :style="{textTransform: noUpperCase ? 'uppercase' : 'none'}" style="padding:0.5rem 1rem;font-size:1.1rem;">            {{description}}
            <i v-if="!dd_open" class="fa fa-angle-down pull-right" style="line-height: 2rem; color:#2d3256"></i>
            <i v-if="dd_open" class="fa fa-angle-up pull-right cursor-pointer" style="line-height: 2rem; color:#e90054"></i>
        </p>
        <transition name="slide-fade">
            <div v-if="dd_open" class="ddfake-open">
                <p v-for="t, index in options" class="ddfake-opt" @click="setSelect(index)" :style="{textTransform: noUpperCase ? 'uppercase' : 'none'}">
	                <span v-if="!localState">
	                    <i v-if="!selected[index]" class="fa fa-fw fa-square-o mr20" style="line-height: 2rem; color:#2d3256"></i>
                        <i v-if="selected[index]" class="fa fa-fw fa-check-square mr20" style="line-height: 2rem; color:#2d3256"></i>
                    </span>
		            <span v-if="localState">
	                    <i v-if="!localArray[index]" class="fa fa-fw fa-square-o mr20" style="line-height: 2rem; color:#2d3256"></i>
                        <i v-if="localArray[index]" class="fa fa-fw fa-check-square mr20" style="line-height: 2rem; color:#2d3256"></i>
		            </span>

                    {{property ? options[index][property] : options[index]}}
                </p>
            </div>
        </transition>
    </div>
</template>
<script>
export default {
  props: [
    "options",
    "description",
    "disabled",
    "selected",
    "property",
    "value",
    "noUpperCase",
    "localState"
  ],
  data() {
    return {
      dd_open: false,
      localArray: []
    };
  },
  methods: {
    setSelect(i) {
      if (this.localState) {
        this.$set(this.localArray, i, !this.localArray[i]);
      }
      if (this.value) {
        this.$emit("select", this.options[i][this.value]);
      } else {
        this.$emit("select", index);
      }
    }
  },

  created() {
    if (this.localState) {
      this.options.forEach((o, i) => {
        this.$set(this.localArray, i, false);
      });
    }
  },

  watch: {
    dd_open() {
      if (this.dd_open === true) {
        this.$emit("clear");
      }
    }
  }
};
</script>
<style scoped lang="scss">
.fakeddcontainer {
  position: relative;
  min-width: 10rem;
}

.fakedd {
  position: relative;
  //margin: 1.5rem 0 0;
  line-height: 2rem;
  padding: 0 0.5rem;
  font-size: 0.75rem;
  min-height: 2rem;
  width: 100%;
  border: solid 1px #dedede;
  //border-radius: 3px;
  //color: black;
  //font-size: 1rem;
}

.ddfake-open {
  background-color: white;
  position: absolute;
  z-index: 2;
  width: 100%;
  border: solid 1px #dedede;
  border-radius: 0;
}

.ddfake-opt {
  display: flex;
  font-size: 1.1rem;
  color: #535353;
  line-height: 3rem;
  z-index: 3;
  cursor: pointer;
  padding: 0 0.5rem;
}

.ddfake-opt:hover {
  //color:white;
  background-color: #f4f4f4;
}

.disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckDd.vue